import { useState } from "react";
import { getAllWarehouses } from "../../../Services/inventoryService";
import { extractErrorMessage } from "../../../Utils/extractErrorMessage";
import { TOAST_MESSAGES } from "../constants";
import toast from "react-hot-toast";

export const useWarehouse = () => {
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState({
    search: null,
    product: null,
    warehouse: null,
  });
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const onPageChange = (newPage) => setPage(newPage);

  const onPageSizeChange = (newSize) => {
    setRowsPerPage(newSize);
    setPage(1);
  };

  const fetchWarehouses = async (params) => {
    setLoading(true);
    let data = null;
    try {
      const response = await getAllWarehouses({
        ...filters,
        limit: rowsPerPage,
        offset: (page - 1) * rowsPerPage,
        ...params,
      });
      if (response.status === 200) {
        setTotalPages(
          Math.max(1, Math.ceil((response.data?.count || 0) / rowsPerPage))
        );
        data = response.data?.results ?? response.data;
      } else {
        const msg =
          extractErrorMessage(response) ||
          TOAST_MESSAGES.FAILED_FETCH_WAREHOUSE;
        toast.error(msg);
      }
    } catch (error) {
      toast.error(
        extractErrorMessage(error) || TOAST_MESSAGES.FAILED_FETCH_WAREHOUSE
      );
    } finally {
      setLoading(false);
      return data;
    }
  };

  return {
    loading,
    filters,
    setFilters,
    page,
    totalPages,
    rowsPerPage,
    onPageChange,
    onPageSizeChange,
    fetchWarehouses,
  };
};
